export interface IReportGroupDropdownHttpResponse {
    id: number;
    reportGroupGuid: string;
    groupName: string;
    groupOrder: number,
    evideLicenseId: number,
    evideLicenseName: string,
}

export class ReportGroupDropdown {
    constructor(
        public id: number,
        public reportGroupGuid: string,
        public groupName: string,
    ) { }

    public static adapt(data: IReportGroupDropdownHttpResponse) {
        return new this(
            data.id,
            data.reportGroupGuid,
            data.groupName,
        );
    }
}

export interface ISaveReportGroupHttpRequest {
    id?: number;
    groupName: string;
    groupOrder: number;
    evideLicenseId: number;
}

export interface IReOrderReportGroupHttpRequest {
    evideLicenseId: number;
    reportGroupIds: number[]
}

export interface IReportGroupHttpResponse {
    id: number;
    reportGroupGuid: string;
    groupName: string;
    groupOrder: number;
    evideLicenseId: number;
    evideLicenseName: string;
}

export class ReportGroup {
    constructor(
        public id: number,
        public reportGroupGuid: string,
        public groupName: string,
        public groupOrder: number,
        public evideLicenseId: number,
        public evideLicenseName: string
    ) { }

    public static adapt(data: IReportGroupHttpResponse) {
        return new this(
            data.id, data.reportGroupGuid, data.groupName,
            data.groupOrder, data.evideLicenseId, data.evideLicenseName
        );
    }

    public static createBlank(evideLicenseId = 0) {
        return new this(0, '', '', 9999, evideLicenseId, '');
    }
}